import Vue from 'vue';
import { mapState } from 'vuex';
// @ts-ignore
import { ReactInVue } from 'vuera';
import { INTERACTION_SET_ACTIVE } from '@/config/constants';

export default Vue.extend({
  components: {},
  data() {
    return {
      dialog: false,
      active: false,
      item: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    ...mapState('interactions', {
      // @ts-ignore
      interactionMode: state => state.interactionMode,
      // @ts-ignore
      interactions: state => state.items
    })
  },
  methods: {
    startRect(e: any) {
      if (!this.interactionMode) {
        return;
      }
      this.active = true;

      this.item = {
        x: e.layerX,
        y: e.layerY,
        width: 0,
        height: 0
      };
    },
    createRect(e: any) {
      if (!this.active) {
        return;
      }
      this.item.width = e.layerX - this.item.x;
      this.item.height = e.layerY - this.item.y;
    },
    finishRect(e: any) {
      this.active = false;
      this.createInteraction(e);
    },
    createInteraction(e: any) {
      if (!this.interactionMode || this.item.width < 10 || this.item.height < 10) {
        return;
      }

      this.dialog = true;
      const { width, height } = e.target.getBoundingClientRect();

      this.$store.commit(INTERACTION_SET_ACTIVE, {
        from: {
          asset: this.$store.state.slides.active._id,
          coord: {
            x: (this.item.x / width) * 100,
            y: (this.item.y / height) * 100,
            w: (this.item.width / width) * 100,
            h: (this.item.height / height) * 100
          }
        }
      });
    }
  }
});
